var exports = {
  "k": "DisableInvitesButton.module__container___V3JLMl",
  "i": "DisableInvitesButton.module__message___V3JLMl",
};

module.exports = exports;
